import React, { JSX, useEffect, useRef, useState } from "react";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Box from "@mui/material/Box";
import { GridColDef, GridPinnedColumnFields } from "@mui/x-data-grid";
import Paper from "@mui/material/Paper";
import {
    Button,
    IconButton,
    Popper,
    TextField,
    Badge,
    Tooltip
} from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import Autocomplete from "@mui/material/Autocomplete";
import Grid from "@mui/material/Grid2";
import Chip from "@mui/material/Chip";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import { ThreeDot } from "react-loading-indicators";
import emptyImage from "../../assets/images/image.png";
import Dialog, { DialogProps } from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import { DataGridPro } from "@mui/x-data-grid-pro";
import defaultlogo from "../../assets/icons/noimg.png";
import {
    getAssignSM,
    getCompanyRfqMetaFilterData,
    getCustomerRfqDataV1,
    getSourcingManagers,
    unAssignSM
} from "../Services/OrgRepo";
import { CertificationDrawer } from "./CertificationDrawer";
import { Link, useNavigate } from "react-router-dom";
import {
    accountManager,
    accountManagerHead,
    NPDManagerHead,
    generateCompanyLogo,
    generatProfilePicUrl,
    getLoggedInEmail,
    getLoggedInUserDepartment,
    getLoggedInUserID,
    Management,
    productionManagerHead,
    qualityManagerHead,
    sourcingManagerHead,
    formatCurrencyValue
} from "../../Utils/Constant";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import EuroIcon from "@mui/icons-material/Euro";
import oligasIcn from "../../assets/icons/oligas.png";
import evAutoIcn from "../../assets/icons/automotive.png";
import power from "../../assets/icons/power.png";
import industry from "../../assets/icons/industry.png";
import aerospace from "../../assets/icons/aerospace.png";
import ActionMenu from "./ActionMenu";
import { showToast } from "../../Components/Toast";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { getCURFQAssignedToMeFilterMetaFieldsApi } from "../Services/FeasibleRFQ";
import CircleIcon from "@mui/icons-material/Circle";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import dayjs from "dayjs";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

interface sourcingManagerData {
    User_Email: string;
    Display_Pic: string;
    User_Name: string;
    id: number;
    User_ID: string;
    User_Role: string;
}
interface assignSMData {
    rfqId: string;
    assigningFromId: string;
    assigningToId: string;
    assigningToEmail: string;
    assigningToName: string;
}
interface unAssignSMData {
    notificationId: string;
    rfqId: string;
    assignedFromId: string;
    assignedToId: string;
    assignedToEmail: string;
    assignedToName: string;
}
export const FRfqList = () => {
    const [value, setValue] = React.useState("1");
    const [searchTerm, setSearchTerm] = useState("");
    const [rows, setRows] = useState<string[]>([]);

    const [rowsSM, setRowsSM] = useState<sourcingManagerData[]>([]);
    const [rowsSMassign, setRowsSMassign] = useState<sourcingManagerData[]>([]);
    const [feasibleActionHolder, setFeasiableActionHolder] = useState(false);

    const [filteredRows, setFilteredRows] = useState(rows);
    const [selectedRows, setSelectedRows] = useState<string[]>([]);
    const [selectedRowsForAcceptAndReject, selSelectedRowsForAcceptAndReject] =
        useState([]);
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedSourcingManager, setSelectedSourcingManager] = useState([]);
    const [selectedIndustry, setSelectedIndustry] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState([]);
    const [selectedMarginRange, setSelectedMarginRange] = useState([]);
    const [selectedKeyAccountManager, setSelectedKeyAccountManager] = useState(
        []
    );
    const [
        filteredSelectedSourcingManager,
        setFilteredSelectedSourcingManager
    ] = useState([]);
    const [filteredSelectedIndustry, setFilteredSelectedIndustry] = useState(
        []
    );
    const [filteredSelectedStatus, setFilteredSelectedStatus] = useState([]);
    const [filteredSelectedCompany, setFilteredSelectedCompany] = useState([]);
    const [filteredSelectedMarginRange, setFilteredSelectedMarginRange] =
        useState([]);
    const [
        filteredSelectedKeyAccountManager,
        setFilteredSelectedKeyAccountManager
    ] = useState([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isLoadingSM, setIsLoadingSM] = useState<boolean>(false);
    const [isLoadingAssignUnAssign, setIsLoadingAssignUnAssign] =
        useState<boolean>(false);

    const [isFilterLoading, setIsFilterLoading] = useState<boolean>(false);
    const searchInputRef = useRef<HTMLInputElement>(null);
    const [selectedRow, setSelectedRow] = useState(null);
    const [openDrawer, setOpenDrawer] = useState(false);
    const [filterOptions, setFilterOptions] = useState<{
        [key: string]: { title: string; value: string }[];
    }>({});
    const [isApplyFilter, setIsApplyFilter] = useState<Boolean>(false);
    const [readNew, setNewRead] = useState<Boolean>(false);
    const [openDialog, setOpenDialog] = React.useState(false);
    const [maxWidth, setMaxWidth] =
        React.useState<DialogProps["maxWidth"]>("xs");
    const [isButtonDisable, setIsButtonDisable] = useState<boolean>(false);
    const [reasonForRejection, setReasonForRejection] = useState<string>("");
    const [removeFilter, setRemoveFilter] = useState<boolean>(false);
    const popperRef = useRef<HTMLDivElement>(null);
    const [paginationModel, setPaginationModel] = React.useState({
        page: 0,
        pageSize: 10 // Default page size
    });
    const navigate = useNavigate();

    const showLoader = isLoading;
    const showGrid =
        !isLoading && (filteredRows.length > 0 || selectedRows.length > 0);
    const showEmpty = !isLoading && filteredRows.length === 0;

    const userDepartment = getLoggedInUserDepartment();
    let feasibleDeptTab = null;
    if (
        userDepartment === "Sourcing" ||
        userDepartment === "Account Management" ||
        userDepartment === "Management"
    ) {
        feasibleDeptTab = "Sourcing";
    } else if (userDepartment === "NPD" || userDepartment === "Production") {
        feasibleDeptTab = userDepartment;
    }

    const [tabValue, setTabValue] = React.useState(feasibleDeptTab);

    const [sourcingTeamMembers, setSourcingTeamMembers] = useState([]),
        [productionTeamMembers, setProductionTeamMembers] = useState([]),
        [NPDTeamMembers, setNPDTeamMembers] = useState([]);

    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        setTabValue(newValue);
        setAnchorEl(null);
        handleClearAll();
        handleClearAllChip();
    };

    const [pinnedColumns, setPinnedColumns] =
        React.useState<GridPinnedColumnFields>({
            left: ["rfqID", "rfqName"],
            right: ["status", "teamMember"]
        });
    const handlePinnedColumnsChange = React.useCallback(
        (updatedPinnedColumns: GridPinnedColumnFields) => {
            setPinnedColumns(updatedPinnedColumns);
        },
        []
    );
    const handleClickOpenDialog = () => {
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
        setReasonForRejection("");
    };

    const handleOpenDrawer = async (row: any) => {
        setSelectedRow(row);
        setOpenDrawer(true);
    };

    const handleCloseDrawer = () => {
        setOpenDrawer(false);
    };

    const fetchCustomerRfqData = async (
        params: string,
        assignAndUnassign: boolean,
        department?: string
    ) => {
        if (assignAndUnassign) {
            setIsLoading(false);
        } else {
            setIsLoading(true);
        }
        setNewRead(false);
        try {
            // let paylod =
            //   getLoggedInUserDepartment() === "Account Management" ? params : "";
            let paylod = {};
            if (getLoggedInUserDepartment() === "Account Management") {
                paylod = {
                    KAMID: params
                };
            } else {
                paylod = {
                    userEmail: getLoggedInEmail()
                };
            }
            paylod = {
                userEmail: getLoggedInEmail(),
                status: "Feasible RFQs",
                department: department
            };
            const response = await getCustomerRfqDataV1(paylod);
            if (response?.status) {
                setIsLoading(false);
                let data = response?.data?.map((item: any, index: number) => ({
                    id: index + 1, // DataGrid requires a unique `id` field
                    rfqID: item?.rfqID || `P${index + 1}`, // Generate an ID if missing
                    rfqName: item?.rfqName,
                    companyName: item?.companyName,
                    marginRange: item?.marginRange,
                    partDetails: item?.listOfParts?.join(", "),
                    totalOrderValue: item?.totalOrderValue,
                    pricetype: item?.pricetype || "-",
                    preferredCurrency: item?.preferredCurrency,
                    industryType: item?.industryType,
                    mandatoryCertifications:
                        item?.mandatoryCertifications.join(", "),
                    incoTerms: item?.incoTerms,
                    keyAccountManager: `${item?.keyAccountManager || ""}`,
                    keyAccountManagerFilePath: item?.keyAccountManagerFilePath,
                    keyAccountManagerID: item?.keyAccountManagerID,
                    emailId: item?.Primary_Contact_Email || "-",
                    Added_Date: item?.Added_Date,
                    addedOn: item?.addedOn,
                    // ? new Intl.DateTimeFormat("en-GB", {
                    //     day: "2-digit",
                    //     month: "2-digit",
                    //     year: "numeric",
                    //   }).format(new Date(item.addedOn))
                    // : null,
                    lastUpdateOn: item?.lastUpdateOn,
                    type_of_order: item?.type_of_order || "",
                    // ? new Intl.DateTimeFormat("en-GB", {
                    //     day: "2-digit",
                    //     month: "2-digit",
                    //     year: "numeric",
                    //   }).format(new Date(item.lastUpdateOn))
                    // : null,

                    status: item?.status,
                    coRfqID: item?.ID,
                    isNew: item?.isNew,
                    notificationID: item?.notificationID,
                    companyID: item?.companyID,
                    companyRecId: item?.companyRecId,
                    companyLogo: item?.companyLogo,
                    ID: item?.ID,
                    rfqStartDate: item?.rfqStartDate,
                    rfqEndDate: item?.rfqEndDate,
                    notificationId: item?.notificationId || "",
                    assigneeName: item?.assigneeName || "",
                    assigneeID: item?.assigneeID || "",
                    assigneeEmailId: item?.assigneeEmailId || "",
                    assigneeProfilePic: item?.assigneeProfilePic || "",
                    assignedDepartment: tabValue
                }));
                setRows(data);
                setFilteredRows(data);
            } else {
                setRows([]);
                setFilteredRows([]);
            }
        } catch (error) {
            setIsLoading(false);
            setRows([]);
            setFilteredRows([]);
        }
    };

    const fetchSourcingManagers = async () => {
        setIsLoadingSM(true);
        try {
            const response = await getSourcingManagers();
            console.log("response all managers :: ", response);

            if (response?.status) {
                setRowsSM(response?.data);
            } else {
                setRowsSM([]);
            }
        } catch (error) {
            console.error(error);
            setRowsSM([]);
        } finally {
            setIsLoadingSM(false);
        }
    };

    const assignSMapi = async (payload: any) => {
        setIsLoadingAssignUnAssign(true);
        try {
            const assignSMApiReq = {
                rfqId: payload?.rfqId,
                assigningFromId: getLoggedInUserID(),
                assigningToId: payload?.userId,
                assigningToEmail: payload?.userEmail,
                assigningToName: payload?.name
            };
            const response = await getAssignSM(assignSMApiReq);
            if (response?.status) {
                setIsLoadingAssignUnAssign(false);
                showToast({
                    message: `${payload?.name} assigned to ${payload?.coRfqId}`,
                    type: "success"
                });
            } else {
                setIsLoadingAssignUnAssign(false);
            }
        } catch (error) {
            console.error("Error assigning sourcing manager:", error);
        } finally {
            // setIsLoadingSM(false);
        }
    };

    const unAssignSMapi = async (payload) => {
        setIsLoadingAssignUnAssign(true);
        try {
            const unAssignSMApiReq = {
                notificationId: payload?.notificationId,
                rfqId: payload?.ID,
                assignedFromId: getLoggedInUserID(),
                assignedToId: payload?.assigneeID,
                assignedToEmail: payload?.assigneeEmailId,
                assignedToName: payload?.assigneeName
            };
            const response = await unAssignSM(unAssignSMApiReq);
            if (response?.status) {
                setIsLoadingAssignUnAssign(false);
                showToast({
                    message: `${payload?.assigneeName} removed from ${payload?.rfqID}.`,
                    type: "error"
                });
            } else {
                setIsLoadingAssignUnAssign(false);
            }
        } catch (error) {
            console.error("Error unassigning sourcing manager:", error);
        } finally {
            // setIsLoadingSM(false);
        }
    };

    const [isInitialRender, setIsInitialRender] = useState(true);

    useEffect(() => {
        const init = async () => {
            setIsLoading(true);
            try {
                // await fetchCustomerRfqData(getLoggedInUserID(), false);
                await fetchSourcingManagers();
            } finally {
                // setIsLoading(false);
            }

            // reset filters AFTER data load
            setAnchorEl(null);
            setSelectedIndustry([]);
            setSelectedStatus([]);
            setSelectedMarginRange([]);
            setSelectedCompany([]);
            setSelectedKeyAccountManager([]);
        };

        init();
    }, []);

    useEffect(() => {
        let isCancelled = false;

        const loadData = async () => {
            // Fetch RFQ data
            await fetchCustomerRfqData(getLoggedInUserID(), false, tabValue);
            if (isCancelled) return;

            // Feasible action logic
            setFeasiableActionHolder(tabValue === getLoggedInUserDepartment());

            // Fetch filters if empty
            if (!filterOptions || Object.keys(filterOptions).length === 0) {
                fetchFilterData();
            }

            // Update team members safely using previous state
            setFilterOptions((prev) => {
                if (!prev?.teamMemberOptions) return prev;

                const teamMap = {
                    Sourcing: sourcingTeamMembers,
                    Production: productionTeamMembers,
                    NPD: NPDTeamMembers
                };

                return teamMap[tabValue]
                    ? { ...prev, teamMemberOptions: teamMap[tabValue] }
                    : prev;
            });
        };

        loadData();

        return () => {
            isCancelled = true;
        };
    }, [tabValue]);

    const handleClearAll = () => {
        setSelectedSourcingManager([]);
        setSelectedIndustry([]);
        setSelectedStatus([]);
        setSelectedMarginRange([]);
        setSelectedCompany([]);
        setSelectedKeyAccountManager([]);
    };
    const handleClearAllChip = () => {
        setSelectedSourcingManager([]);
        setSelectedIndustry([]);
        setSelectedStatus([]);
        setSelectedMarginRange([]);
        setSelectedCompany([]);
        setSelectedKeyAccountManager([]);

        setFilteredSelectedSourcingManager([]);
        setFilteredSelectedIndustry([]);
        setFilteredSelectedStatus([]);
        setFilteredSelectedMarginRange([]);
        setFilteredSelectedKeyAccountManager([]);
        setFilteredSelectedCompany([]);
        setFilteredRows(rows);
        setIsApplyFilter(false);
    };

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        if (
            Object.keys(filterOptions)?.length === 0 ||
            filterOptions?.companyOptions
        ) {
            fetchFilterData();
        }
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
        setSelectedSourcingManager(filteredSelectedSourcingManager);
        setSelectedIndustry(filteredSelectedIndustry);
        setSelectedStatus(filteredSelectedStatus);
        setSelectedMarginRange(filteredSelectedMarginRange);
        setSelectedCompany(filteredSelectedCompany);
        setSelectedKeyAccountManager(filteredSelectedKeyAccountManager);
    };

    // Handle search input change
    const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
        const search = event?.target?.value;
        setSearchTerm(search);

        if (search?.length >= 3) {
            const filtered = rows?.filter((row) =>
                ["rfqID", "rfqName"].some(
                    (key) =>
                        typeof row[key] === "string" &&
                        row[key].toLowerCase().includes(search.toLowerCase())
                )
            );
            setFilteredRows(filtered);
        } else {
            setFilteredRows(rows);
        }
    };

    useEffect(() => {
        if (searchInputRef.current) {
            searchInputRef.current.focus();
        }
    }, [searchTerm]);
    const industryIcons = {
        "Oil & Gas": oligasIcn,
        "Power & Transmission": power,
        "EV/Automotive": evAutoIcn,
        "Industrial Products": industry,
        "Aerospace & Defence": aerospace
    };
    const IndustryTypeCell = ({
        value,
        isIndustryType
    }: {
        value?: string;
        isIndustryType?: boolean;
    }) => {
        const [expanded, setExpanded] = useState(false);
        const types = value?.split(", ") || [];

        const displayedTypes = expanded ? types : types.slice(0, 2);
        const remainingCount = types.length - 2;

        return (
            <Box
                sx={{
                    gap: 0.5,
                    alignItems: "center",
                    height: "100%",
                    margin: "5px 0 3px"
                }}
            >
                {displayedTypes?.map((type, idx) =>
                    type ? (
                        <Chip
                            size="small"
                            key={idx}
                            label={type}
                            sx={{ margin: "5px 0px 0px 5px" }}
                            avatar={
                                isIndustryType && industryIcons[type] ? (
                                    <img
                                        src={`${industryIcons[type]}`}
                                        alt={value}
                                        style={{ width: 15, height: 15 }}
                                    />
                                ) : null
                            }
                        />
                    ) : (
                        "-"
                    )
                )}
                {!expanded && remainingCount > 0 && (
                    <Chip
                        size="small"
                        label={`+${remainingCount}`}
                        sx={{ cursor: "pointer", margin: "5px 0px 0px 5px" }}
                        onClick={() => setExpanded(true)}
                    />
                )}
                {expanded && (
                    <IconButton
                        size="small"
                        onClick={() => setExpanded(false)}
                        sx={{ margin: "5px 0px 0px 5px" }}
                    >
                        <CancelIcon fontSize="small" />
                    </IconButton>
                )}
            </Box>
        );
    };
    const getCurrencyIcon = (currency) => {
        switch (currency) {
            case "INR":
                return <CurrencyRupeeIcon sx={{ fontSize: "0.875rem" }} />;
            case "USD":
                return <AttachMoneyIcon sx={{ fontSize: "0.875rem" }} />;
            case "EUR":
                return <EuroIcon sx={{ fontSize: "0.875rem" }} />;
            default:
                return null;
        }
    };
    function parseCustomDate(dateStr: string) {
        return dayjs(dateStr, "DD-MMM-YYYY HH:mm:ss").toDate();
    }

    const isHighValueRfq = (row) => {
        const { preferredCurrency, totalOrderValue } = row;

        return (
            (preferredCurrency === "INR" && totalOrderValue >= 5000000) ||
            (preferredCurrency === "EUR" && totalOrderValue >= 50000) ||
            (preferredCurrency === "USD" && totalOrderValue >= 50000)
        );
    };

    const columns: GridColDef[] = [
        {
            field: "rfqID",
            headerName: "CORFQ ID",
            width: 100,
            disableColumnMenu: true,
            renderCell: (params) => {
                const payload = {
                    rfqData: params?.row,
                    from: "FRfqList"
                };
                return (
                    <Link
                        to="/layout/CURFQDetails"
                        target="_blank"
                        state={{ payload }}
                        onClick={() => {
                            localStorage.setItem(
                                "CURFQDetails",
                                JSON.stringify(payload)
                            );
                        }}
                        style={{
                            textDecoration: "none"
                        }}
                    >
                        {params?.value}
                    </Link>
                );
            }
        },
        {
            field: "rfqName",
            headerName: "CORFQ Name",
            width: 200,
            disableColumnMenu: true,
            cellClassName: (params) => {
                return isHighValueRfq(params?.row) ? "rfq-high-value-cell" : "";
            },
            renderCell: (params) => {
                const highValue = isHighValueRfq(params?.row);
                const payload = {
                    rfqData: params?.row,
                    from: "FRfqList"
                };
                return (
                    <>
                        {highValue && (
                            <>
                                <div className="highlightChip">
                                    High value{" "}
                                    <TrendingUpIcon sx={{ fontSize: "1rem" }} />
                                </div>
                            </>
                        )}
                        <Link
                            to="/layout/CURFQDetails"
                            target="_blank"
                            state={{ payload }}
                            onClick={() => {
                                localStorage.setItem(
                                    "CURFQDetails",
                                    JSON.stringify(payload)
                                );
                            }}
                            style={{
                                textDecoration: "none",
                                display: "flex",
                                justifyContent: "space-between",
                                width: "100%",
                                alignItems: "center"
                            }}
                        >
                            <span>{params?.value}</span>
                            {!accountManagerHead() && params?.row?.isNew && (
                                // <Chip
                                //   label={"New"}
                                //   size="small"
                                //   color="primary"
                                //   sx={{ marginLeft: "1.5rem" }}
                                // />
                                <CircleIcon
                                    sx={{ fontSize: "12px", color: " #1976d2" }}
                                />
                            )}
                        </Link>
                    </>
                );
            }
        },
        {
            field: "companyName",
            headerName: "Company Name",
            minWidth: 200,
            disableColumnMenu: true,
            renderCell: (params) => {
                const name = params?.value || "";
                const truncatedName = name;
                const logoUrl = params?.row?.companyLogo
                    ? generateCompanyLogo(
                          params?.row?.companyRecId,
                          params?.row?.companyLogo
                      )
                    : defaultlogo;
                const payload = {
                    companyRecId: params.row?.companyRecId,
                    compDetails: params.row,
                    from: "FRfqList"
                };
                return (
                    <Link
                        to="/layout/CompanyProfilePage"
                        target="_blank"
                        state={{ payload }}
                        onClick={() => {
                            localStorage.setItem(
                                "CompanyProfilePage",
                                JSON.stringify(payload)
                            );
                        }}
                        style={{ textDecoration: "none" }}
                    >
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                                // overflow: "hidden",
                                // textOverflow: "ellipsis",
                                // whiteSpace: "nowrap",
                                height: "100%",
                                cursor: "pointer"
                            }}
                        >
                            {logoUrl && (
                                <img
                                    src={logoUrl}
                                    alt={name}
                                    width={24}
                                    height={24}
                                    style={{
                                        borderRadius: "50%",
                                        border: "1px solid #d8d8d8"
                                    }}
                                />
                            )}
                            <Typography variant="body2" className="hoverClr">
                                {truncatedName}
                            </Typography>
                        </Box>
                    </Link>
                );
            }
        },

        {
            field: "rfqStartDate",
            headerName: "CORFQ Start Date ",
            width: 150,
            disableColumnMenu: true
        },

        {
            field: "rfqEndDate",
            headerName: "CORFQ End Date",
            width: 150,
            disableColumnMenu: true
        },
        {
            field: "totalOrderValue",
            headerName: "Total Order Value",
            width: 150,
            disableColumnMenu: true,
            renderCell: (params) => {
                const value = params?.value;
                const currency = params?.row?.preferredCurrency;
                const formattedValue = formatCurrencyValue(value, currency);
                return (
                    <div style={{ display: "block" }}>
                        <Typography
                            variant="body2"
                            display="flex"
                            alignItems="center"
                        >
                            {getCurrencyIcon(params?.row?.preferredCurrency)}
                            <span style={{ paddingLeft: "5px" }}>
                                {formattedValue}
                            </span>
                            <Tooltip title={params?.row?.pricetype}>
                                <IconButton>
                                    <InfoOutlinedIcon
                                        style={{ fontSize: "16px" }}
                                    />
                                </IconButton>
                            </Tooltip>
                        </Typography>
                        <Typography
                            variant="caption"
                            color="text.secondary"
                            display="block"
                        >
                            {params?.row?.preferredCurrency}
                        </Typography>
                    </div>
                );
            }
        },

        {
            field: "marginRange",
            headerName: "Margin Range",
            width: 200,
            disableColumnMenu: true
        },

        // {
        //   field: "partDetails",
        //   headerName: "List of parts",
        //   width: 200,
        //   disableColumnMenu: true,
        //   renderCell: (params) => <IndustryTypeCell value={params?.value} />,
        // },
        // {
        //   field: "industryType",
        //   headerName: "Industry type",
        //   width: 200,
        //   disableColumnMenu: true,
        //   renderCell: (params) => (
        //     <IndustryTypeCell value={params?.value} isIndustryType={true} />
        //   ),
        // },

        ...(!accountManager()
            ? [
                  {
                      field: "keyAccountManager",
                      headerName: "Key Account Manager",
                      width: 200,
                      disableColumnMenu: true,
                      renderCell: (params) => {
                          const name = params?.value || "";
                          return (
                              <Grid
                                  container
                                  spacing={2}
                                  alignItems="center"
                                  width="100%"
                              >
                                  <Grid size={{ xs: 2, md: 2 }}>
                                      <img
                                          src={
                                              generatProfilePicUrl(
                                                  params?.row
                                                      ?.keyAccountManagerID,
                                                  params?.row
                                                      ?.keyAccountManagerFilePath,
                                                  "Profile_Picture"
                                              ) || ""
                                          }
                                          alt="KAM"
                                          width={24}
                                          height={24}
                                          style={{
                                              marginRight: "5px",
                                              borderRadius: "50%"
                                          }}
                                      />
                                  </Grid>
                                  <Grid size={{ xs: 10, md: 10 }}>
                                      <Typography variant="body2" className="">
                                          {name}
                                      </Typography>
                                  </Grid>
                              </Grid>
                          );
                      }
                  }
              ]
            : []),
        // {
        //   field: "addedOn",
        //   headerName: "Added On",
        //   width: 200,
        // },
        {
            field: "lastUpdateOn",
            headerName: "Last Updated On",
            width: 200,
            disableColumnMenu: true,
            sortComparator: (v1, v2) =>
                parseCustomDate(v1).getTime() - parseCustomDate(v2).getTime()
        },
        {
            field: "type_of_order",
            headerName: "Type of order",
            width: 150,
            disableColumnMenu: true,
            renderCell: (params) => {
                if (!params?.value) {
                    return "-";
                }
                return (
                    <Chip
                        variant="outlined"
                        label={params?.value}
                        size="small"
                        color={
                            params?.value === "Recurring Order"
                                ? "info"
                                : "warning"
                        }
                    />
                );
            }
        },
        {
            field: "status",
            headerName: "MMRFQ Status",
            width: 170,
            disableColumnMenu: true,
            cellClassName: () => "first-pinned-right",
            headerClassName: "first-pinned-right",
            renderCell: (params) => {
                return (
                    <Chip
                        label={params?.row?.status}
                        variant="outlined"
                        size="small"
                        color={
                            params?.row?.status === "Internal RFQ Created"
                                ? "info"
                                : params?.row?.status === "Completed" ||
                                    params?.row?.status === "Partners Approved"
                                  ? "success"
                                  : params?.row?.status === "Quotes Received"
                                    ? "secondary"
                                    : "default"
                        }
                    />
                );
            }
        },
        ...(sourcingManagerHead() ||
        accountManagerHead() ||
        accountManager() ||
        qualityManagerHead() ||
        NPDManagerHead() ||
        productionManagerHead() ||
        Management()
            ? [
                  {
                      field: "teamMember",
                      headerName: "Team Member",
                      width: 200,
                      disableColumnMenu: true,

                      renderCell: (params) => {
                          const hasAssignee = !!params?.row?.assigneeEmailId;

                          const fetchAssignedDetails = hasAssignee
                              ? [
                                    {
                                        name: params?.row?.assigneeName,
                                        avatar: generatProfilePicUrl(
                                            params?.row?.assigneeID,
                                            params?.row?.assigneeProfilePic,
                                            "Profile_Picture"
                                        ),
                                        userId: params?.row?.assigneeID,
                                        userEmail: params?.row?.assigneeEmailId,
                                        rfqId: params?.row?.ID,
                                        coRfqId: params?.row?.rfqID
                                    }
                                ]
                              : [];

                          // console.log("params", params?.row);

                          return (
                              <ActionMenu
                                  rowsSM={rowsSM}
                                  fetchAssignedDetails={fetchAssignedDetails}
                                  params={params?.row}
                                  onAssign={async (params) => {
                                      await assignSMapi(params); // implement
                                      fetchCustomerRfqData(
                                          getLoggedInUserID(),
                                          true,
                                          tabValue
                                      );
                                  }}
                                  onRemove={async (params) => {
                                      await unAssignSMapi(params); // implement
                                      // fetchCustomerRfqData(getLoggedInUserID(), true);
                                  }}
                                  feasibleAction={feasibleActionHolder}
                              />
                          );
                      }
                  }
              ]
            : [])

        // {
        //   field: "action",
        //   headerName: "Action",
        //   width: 100,
        //   disableColumnMenu: true,
        //   renderCell: (params) => <ActionMenu />,
        // },
    ];

    const finalColumns = columns;

    /**Filter functionality start from here */
    function extractOptions(apiResponse: any[], keyName: string) {
        const section = apiResponse.find((item) => item[keyName]);
        if (!section) return [];

        // Handle keyAccountManager separately as it is a direct array
        if (Array.isArray(section[keyName])) {
            return section[keyName].map((name) => ({
                key: name,
                title: name
            }));
        }

        // Handle objects with choices
        if (section[keyName]?.choices) {
            return section[keyName].choices.map(
                (item: { key: any; link_name: any; value: any }) => ({
                    key: item.key || item.link_name || "unknown_key",
                    title: item.value || item.link_name || "Unknown"
                })
            );
        }

        return [];
    }

    // const fetchFilterData = async () => {
    //   setIsFilterLoading(true);
    //   try {
    //     const filterData = await getCompanyRfqMetaFilterData();

    //     if (filterData?.status) {
    //       let apiResponseStatus = [];
    //       type CompanyType = {
    //         company: string[];
    //       };
    //       const companyDetails: string[] = Array.from(
    //         new Set(rows?.map((item: any) => item?.companyName) ?? [])
    //       );

    //       const filterDataStatus =
    //         await getCURFQAssignedToMeFilterMetaFieldsApi();
    //       if (filterDataStatus?.status) {
    //         apiResponseStatus = filterDataStatus?.data;
    //       }

    //       const company: CompanyType[] = [{ company: companyDetails }];
    //       const apiResponse = filterData?.data;
    //       const sourcingManagerOptions = extractOptions(
    //         apiResponse,
    //         "sourcing_managers"
    //       );
    //       console.log("apiResponse", apiResponse)
    //       console.log("sourcingManagerOptions", sourcingManagerOptions);
    //       const industryOptions = extractOptions(apiResponse, "industryType");
    //       // const rfqOptions = extractOptions(apiResponse, "rfqName");
    //       const statusOptions = extractOptions(apiResponseStatus, "status");
    //       const marginOptions = extractOptions(apiResponse, "marginRange");
    //       const companyOptions = extractOptions(company, "company");
    //       const keyAccountManagerOptions = extractOptions(
    //         apiResponse,
    //         "keyAccountManager"
    //       );
    //       const obj = {
    //         sourcingManagerOptions,
    //         industryOptions,
    //         // rfqOptions,
    //         statusOptions,
    //         marginOptions,
    //         companyOptions,
    //         keyAccountManagerOptions,
    //       };
    //       setFilterOptions(obj);
    //     }
    //     setIsFilterLoading(false);
    //   } catch (error) {
    //     setIsFilterLoading(false);
    //   }
    // };

    const fetchFilterData = async () => {
        setIsFilterLoading(true);
        try {
            // Fetch both APIs
            const filterData = await getCompanyRfqMetaFilterData();
            const filterDataStatus =
                await getCURFQAssignedToMeFilterMetaFieldsApi();

            let apiResponseCompany = [];
            let apiResponseStatus = [];
            let teamMemberLists = [];

            if (filterData?.status) {
                apiResponseCompany = filterData?.data;
            }
            if (filterDataStatus?.status) {
                apiResponseStatus = filterDataStatus?.data;
            }

            // ✅ Build company list from existing rows
            type CompanyType = {
                company: string[];
            };
            const companyDetails: string[] = Array.from(
                new Set(rows?.map((item: any) => item?.companyName) ?? [])
            );
            const company: CompanyType[] = [{ company: companyDetails }];

            const sourcingManagers = extractOptions(
                apiResponseStatus,
                "sourcing_managers"
            );

            setSourcingTeamMembers(sourcingManagers);

            const productionManagers = extractOptions(
                apiResponseStatus,
                "production_managers"
            );

            setProductionTeamMembers(productionManagers);

            const npdManagers = extractOptions(
                apiResponseStatus,
                "npd_managers"
            );

            setNPDTeamMembers(npdManagers);

            // ✅ Extract all dropdown options

            // const assignedManagers = extractOptions(
            //   apiResponseStatus,
            //   "corfq_assigned_to_managers"
            // );

            // const sourcingManagerOptions = [
            //   ...(sourcingManagers || []),
            //   ...(assignedManagers || []),
            // ];

            const industryOptions = extractOptions(
                apiResponseCompany,
                "industryType"
            );
            const statusOptions = extractOptions(apiResponseStatus, "status");
            const marginOptions = extractOptions(
                apiResponseCompany,
                "marginRange"
            );
            const companyOptions = extractOptions(company, "company");

            // ✅ Key account managers come from the same status API response
            const keyAccountManagerOptions = extractOptions(
                apiResponseStatus,
                "key_account_managers"
            );

            if (tabValue === `Production`) {
                teamMemberLists = productionManagers;
            } else if (tabValue === `NPD`) {
                teamMemberLists = npdManagers;
            } else {
                teamMemberLists = sourcingManagers;
            }

            // ✅ Combine all filter options
            const obj = {
                teamMemberOptions: teamMemberLists,
                industryOptions,
                statusOptions,
                marginOptions,
                companyOptions,
                keyAccountManagerOptions
            };

            setFilterOptions(obj);
        } catch (error) {
            console.error("Error fetching filter data:", error);
        } finally {
            setIsFilterLoading(false);
        }
    };

    const filterData = (
        rows: any[],
        filters: {
            sourcingManager: any;
            industry: any;
            status: any;
            marginRange: any;
            keyAccountManager: any;
            company: any;
        }
    ) => {
        return rows?.filter(
            (row: {
                assigneeName: string;
                industryType: string;
                status: string;
                companyName: string;
                marginRange: string;

                keyAccountManager: string;
            }) => {
                // Convert row values to lowercase arrays for comparison
                const sourcingManagerArray =
                    row?.assigneeName?.toLowerCase()?.split(/\s*,\s*/) || [];
                const industryArray =
                    row?.industryType?.toLowerCase().split(/\s*,\s*/) || [];
                const statusArray =
                    row?.status?.toLowerCase().split(/\s*,\s*/) || [];
                const companyArray =
                    row?.companyName?.toLowerCase().split(/\s*,\s*/) || [];
                const marginRangeArray =
                    row?.marginRange?.toLowerCase().split(/\s*,\s*/) || [];
                const keyAccountManagerArray =
                    row?.keyAccountManager?.toLowerCase().split(/\s*,\s*/) ||
                    [];

                // Get filter values, ignore empty ones
                const {
                    sourcingManager = [],
                    industry = [],
                    status = [],
                    company = [],
                    marginRange = [],
                    keyAccountManager = []
                } = filters;

                // Check if each applied filter matches
                const sourcingManagerMatch =
                    sourcingManager?.length === 0 ||
                    sourcingManager?.some((loc: string) =>
                        sourcingManagerArray.includes(loc.toLowerCase())
                    );
                const industryMatch =
                    industry?.length === 0 ||
                    industry?.some((ind: string) =>
                        industryArray?.includes(ind.toLowerCase())
                    );
                const statusMatch =
                    status?.length === 0 ||
                    status?.some((stat: string) =>
                        statusArray?.includes(stat.toLowerCase())
                    );
                const companyMatch =
                    company?.length === 0 ||
                    company?.some((cert: string) =>
                        companyArray?.includes(cert.toLowerCase())
                    );
                const marginRangeMatch =
                    marginRange?.length === 0 ||
                    marginRange?.some((m: string) =>
                        marginRangeArray?.includes(m.toLowerCase())
                    );

                const keyAccounManagerMatch =
                    keyAccountManager?.length === 0 ||
                    keyAccountManager?.some((loc: string) =>
                        keyAccountManagerArray.includes(loc.toLowerCase())
                    );

                // **Must match ALL applied filters**
                return (
                    sourcingManagerMatch &&
                    industryMatch &&
                    statusMatch &&
                    companyMatch &&
                    marginRangeMatch &&
                    keyAccounManagerMatch
                );
            }
        );
    };

    const handleApply = async () => {
        setIsApplyFilter(true);
        let filters = {
            sourcingManager:
                selectedSourcingManager?.map((item) =>
                    item?.title?.toLowerCase()
                ) || [],
            industry:
                selectedIndustry?.map((item) => item?.title.toLowerCase()) ||
                [],
            status:
                selectedStatus?.map((item) => item?.title.toLowerCase()) || [],

            marginRange:
                selectedMarginRange?.map((item) => item?.title.toLowerCase()) ||
                [],
            keyAccountManager:
                selectedKeyAccountManager?.map((item) =>
                    item?.title.toLowerCase()
                ) || [],
            company:
                selectedCompany?.map((item) => item?.title.toLowerCase()) || []
        };

        const filteredResults = filterData(rows, filters);
        setFilteredRows(filteredResults);
        setAnchorEl(null);
        setFilteredSelectedSourcingManager(selectedSourcingManager);
        setFilteredSelectedIndustry(selectedIndustry);
        setFilteredSelectedStatus(selectedStatus);
        setFilteredSelectedCompany(selectedCompany);
        setFilteredSelectedKeyAccountManager(selectedKeyAccountManager);
        setFilteredSelectedMarginRange(selectedMarginRange);

        if (
            selectedIndustry?.length == 0 &&
            selectedMarginRange?.length == 0 &&
            selectedStatus?.length == 0 &&
            selectedKeyAccountManager?.length == 0 &&
            selectedCompany?.length === 0 &&
            selectedSourcingManager?.length === 0
        ) {
            setFilteredRows(rows);
            setFilteredSelectedSourcingManager(selectedSourcingManager);
            setFilteredSelectedIndustry(selectedIndustry);
            setFilteredSelectedStatus(selectedStatus);
            setFilteredSelectedCompany(selectedCompany);
            setFilteredSelectedKeyAccountManager(selectedKeyAccountManager);
            setFilteredSelectedMarginRange(selectedMarginRange);
        }
    };

    const handleRemoveFilter = (category: string, item: { title: any }) => {
        if (removeFilter == true) {
            setRemoveFilter(false);
        } else {
            setRemoveFilter(true);
        }
        switch (category) {
            case "sourcingManager":
                setSelectedSourcingManager((prev) =>
                    prev.filter((i) => i.title !== item.title)
                );
                break;
            case "industry":
                setSelectedIndustry((prev) =>
                    prev.filter((i) => i.title !== item.title)
                );
                break;
            case "status":
                setSelectedStatus((prev) =>
                    prev.filter((i) => i.title !== item.title)
                );
                break;

            case "company":
                setSelectedCompany((prev) =>
                    prev.filter((i) => i.title !== item.title)
                );
                break;
            case "marginRange":
                setSelectedMarginRange((prev) =>
                    prev.filter((i) => i.title !== item.title)
                );
                break;

            case "keyAccountManager":
                setSelectedKeyAccountManager((prev) =>
                    prev.filter((i) => i.title !== item.title)
                );
                break;
            default:
                break;
        }
    };

    // Run `handleApply` after any filter changes
    useEffect(() => {
        handleApply();
        if (
            selectedIndustry?.length == 0 &&
            selectedMarginRange?.length == 0 &&
            selectedKeyAccountManager?.length == 0 &&
            selectedCompany?.length === 0 &&
            selectedSourcingManager?.length === 0
        ) {
            setIsApplyFilter(false);
        }
    }, [removeFilter]);

    return (
        <>
            <Breadcrumbs aria-label="breadcrumb" sx={{ marginBottom: "10px" }}>
                <Link
                    to="/layout/Dashboard"
                    style={{
                        color: "#0070BA",
                        fontSize: "14px",
                        textDecoration: "none"
                    }}
                >
                    Home
                </Link>
                <Typography sx={{ fontSize: "14px" }}>
                    Feasible CORFQs
                </Typography>
            </Breadcrumbs>
            <Typography variant="h5" mb={1}>
                Feasible CORFQs
            </Typography>
            <Tabs
                value={tabValue}
                onChange={handleChange}
                textColor="primary"
                indicatorColor="primary"
                aria-label="secondary tabs example"
                sx={{
                    "& .MuiTab-root": {
                        textTransform: "none"
                    }
                }}
            >
                <Tab value="Sourcing" label="Sourcing CORFQs" />
                <Tab value="Production" label="Production CORFQs" />
                <Tab value="NPD" label="NPD CORFQs" />
            </Tabs>
            <Box
                sx={{
                    borderRadius: "5px",
                    marginTop: "16px",
                    background: "#fff",
                    padding: "15px"
                }}
            >
                <Grid container spacing={2}>
                    <Grid size={{ xs: 12, md: 7 }}>
                        {rows?.length > 1 && (
                            <Grid container spacing={2}>
                                {/* Search Section */}
                                <Grid size={{ xs: 12, md: 7 }}>
                                    <TextField
                                        label="Search by CORFQ ID & CORFQ Name"
                                        size="small"
                                        variant="outlined"
                                        fullWidth
                                        inputRef={searchInputRef}
                                        value={searchTerm}
                                        onChange={handleSearch}
                                    />
                                </Grid>
                                {/* Filter section */}
                                <Grid
                                    size={{ xs: 12, md: 5 }}
                                    sx={{
                                        color: "grey",
                                        display: "flex",
                                        alignItems: "center"
                                    }}
                                >
                                    <Box>
                                        <IconButton onClick={handleClick}>
                                            <Badge
                                                badgeContent={
                                                    filteredSelectedSourcingManager?.length +
                                                    filteredSelectedIndustry?.length +
                                                    filteredSelectedStatus?.length +
                                                    filteredSelectedMarginRange?.length +
                                                    filteredSelectedKeyAccountManager?.length +
                                                    filteredSelectedCompany?.length
                                                }
                                                color="primary"
                                            >
                                                <FilterAltOutlinedIcon />
                                            </Badge>
                                        </IconButton>

                                        <Popper
                                            open={Boolean(anchorEl)}
                                            anchorEl={anchorEl}
                                            placement="bottom-start"
                                            sx={{ zIndex: 13 }}
                                        >
                                            <Paper
                                                ref={popperRef}
                                                sx={{
                                                    p: 2,
                                                    width: 350,
                                                    boxShadow: 3,
                                                    borderRadius: 2
                                                }}
                                            >
                                                <Box
                                                    sx={{
                                                        fontWeight: "bold",
                                                        mb: 2,
                                                        display: "flex",
                                                        justifyContent:
                                                            "space-between"
                                                    }}
                                                >
                                                    Filter{" "}
                                                    <Button
                                                        size="small"
                                                        variant="outlined"
                                                        onClick={handleClearAll}
                                                    >
                                                        CLEAR ALL
                                                    </Button>
                                                </Box>
                                                {!isFilterLoading ? (
                                                    <Box sx={{ mb: 2 }}>
                                                        <Autocomplete
                                                            multiple
                                                            limitTags={2}
                                                            sx={{
                                                                marginBottom:
                                                                    "15px"
                                                            }}
                                                            size="small"
                                                            id="multiple-limit-tags"
                                                            value={
                                                                selectedSourcingManager
                                                            }
                                                            onChange={(
                                                                event,
                                                                newValue
                                                            ) =>
                                                                setSelectedSourcingManager(
                                                                    newValue ||
                                                                        []
                                                                )
                                                            }
                                                            options={[
                                                                ...(filterOptions?.teamMemberOptions ||
                                                                    [])
                                                            ]?.sort((a, b) =>
                                                                a?.title?.localeCompare(
                                                                    b?.title
                                                                )
                                                            )}
                                                            getOptionLabel={(
                                                                option
                                                            ) =>
                                                                option?.title ||
                                                                ""
                                                            }
                                                            renderOption={(
                                                                props,
                                                                option
                                                            ) => (
                                                                <li
                                                                    {...props}
                                                                    style={{
                                                                        display:
                                                                            "flex",
                                                                        alignItems:
                                                                            "center",
                                                                        gap: 10
                                                                    }}
                                                                >
                                                                    <Typography>
                                                                        {
                                                                            option.title
                                                                        }
                                                                    </Typography>
                                                                </li>
                                                            )}
                                                            renderInput={(
                                                                params
                                                            ) => (
                                                                <TextField
                                                                    {...params}
                                                                    label="Team Member"
                                                                    placeholder="Select Team Member"
                                                                />
                                                            )}
                                                        />
                                                        <Autocomplete
                                                            multiple
                                                            limitTags={2}
                                                            sx={{
                                                                marginBottom:
                                                                    "15px"
                                                            }}
                                                            size="small"
                                                            id="multiple-limit-tags"
                                                            value={
                                                                selectedIndustry
                                                            }
                                                            onChange={(
                                                                event,
                                                                newValue
                                                            ) =>
                                                                setSelectedIndustry(
                                                                    newValue ||
                                                                        []
                                                                )
                                                            }
                                                            options={[
                                                                ...(filterOptions?.industryOptions ||
                                                                    [])
                                                            ]?.sort((a, b) =>
                                                                a?.title?.localeCompare(
                                                                    b?.title
                                                                )
                                                            )}
                                                            getOptionLabel={(
                                                                option
                                                            ) =>
                                                                option?.title ||
                                                                ""
                                                            }
                                                            renderOption={(
                                                                props,
                                                                option
                                                            ) => (
                                                                <li
                                                                    {...props}
                                                                    style={{
                                                                        display:
                                                                            "flex",
                                                                        alignItems:
                                                                            "center",
                                                                        gap: 10
                                                                    }}
                                                                >
                                                                    <Typography>
                                                                        {
                                                                            option.title
                                                                        }
                                                                    </Typography>
                                                                </li>
                                                            )}
                                                            renderInput={(
                                                                params
                                                            ) => (
                                                                <TextField
                                                                    {...params}
                                                                    label="Industry"
                                                                    placeholder="Select Industry Type"
                                                                />
                                                            )}
                                                        />
                                                        <Autocomplete
                                                            multiple
                                                            size="small"
                                                            sx={{
                                                                marginBottom:
                                                                    "15px"
                                                            }}
                                                            limitTags={2}
                                                            id="multiple-limit-tags"
                                                            options={[
                                                                ...(filterOptions?.statusOptions ||
                                                                    [])
                                                            ]?.sort((a, b) =>
                                                                a?.title?.localeCompare(
                                                                    b?.title
                                                                )
                                                            )}
                                                            getOptionLabel={(
                                                                option
                                                            ) =>
                                                                option?.title ||
                                                                ""
                                                            }
                                                            value={
                                                                selectedStatus
                                                            }
                                                            onChange={(
                                                                event,
                                                                newValue
                                                            ) =>
                                                                setSelectedStatus(
                                                                    newValue ||
                                                                        []
                                                                )
                                                            }
                                                            isOptionEqualToValue={(
                                                                option,
                                                                value
                                                            ) =>
                                                                option.title ===
                                                                value?.title
                                                            }
                                                            renderInput={(
                                                                params
                                                            ) => (
                                                                <TextField
                                                                    {...params}
                                                                    label="MMRFQ Status"
                                                                    placeholder="Select MMRFQ Status"
                                                                />
                                                            )}
                                                        />
                                                        <Autocomplete
                                                            multiple
                                                            size="small"
                                                            sx={{
                                                                marginBottom:
                                                                    "15px"
                                                            }}
                                                            limitTags={2}
                                                            id="multiple-limit-tags"
                                                            options={[
                                                                ...(filterOptions?.companyOptions ||
                                                                    [])
                                                            ]?.sort((a, b) =>
                                                                a?.title?.localeCompare(
                                                                    b?.title
                                                                )
                                                            )}
                                                            value={
                                                                selectedCompany
                                                            }
                                                            onChange={(
                                                                event,
                                                                newValue
                                                            ) =>
                                                                setSelectedCompany(
                                                                    newValue ||
                                                                        []
                                                                )
                                                            }
                                                            getOptionLabel={(
                                                                option
                                                            ) =>
                                                                option?.title ||
                                                                ""
                                                            }
                                                            isOptionEqualToValue={(
                                                                option,
                                                                value
                                                            ) =>
                                                                option.title ===
                                                                value?.title
                                                            }
                                                            //  disabled={(selectedIndustry || []).length == 0}
                                                            renderInput={(
                                                                params
                                                            ) => (
                                                                <TextField
                                                                    {...params}
                                                                    label="Company"
                                                                    placeholder="Select Company"
                                                                />
                                                            )}
                                                        />
                                                        <Autocomplete
                                                            multiple
                                                            size="small"
                                                            sx={{
                                                                marginBottom:
                                                                    "15px"
                                                            }}
                                                            limitTags={2}
                                                            id="multiple-limit-tags"
                                                            options={[
                                                                ...(filterOptions?.marginOptions ||
                                                                    [])
                                                            ]?.sort((a, b) =>
                                                                a?.title?.localeCompare(
                                                                    b?.title
                                                                )
                                                            )}
                                                            getOptionLabel={(
                                                                option
                                                            ) =>
                                                                option?.title ||
                                                                ""
                                                            }
                                                            value={
                                                                selectedMarginRange
                                                            }
                                                            onChange={(
                                                                event,
                                                                newValue
                                                            ) =>
                                                                setSelectedMarginRange(
                                                                    newValue ||
                                                                        []
                                                                )
                                                            }
                                                            isOptionEqualToValue={(
                                                                option,
                                                                value
                                                            ) =>
                                                                option.title ===
                                                                value?.title
                                                            }
                                                            renderInput={(
                                                                params
                                                            ) => (
                                                                <TextField
                                                                    {...params}
                                                                    label="Margin Range"
                                                                    placeholder="Select Margin Range"
                                                                />
                                                            )}
                                                        />

                                                        {(accountManagerHead() ||
                                                            sourcingManagerHead() ||
                                                            qualityManagerHead() ||
                                                            productionManagerHead() ||
                                                            NPDManagerHead() ||
                                                            Management()) && (
                                                            <Autocomplete
                                                                multiple
                                                                size="small"
                                                                sx={{
                                                                    marginBottom:
                                                                        "15px"
                                                                }}
                                                                limitTags={2}
                                                                id="multiple-limit-tags"
                                                                options={[
                                                                    ...(filterOptions?.keyAccountManagerOptions ||
                                                                        [])
                                                                ]?.sort(
                                                                    (a, b) =>
                                                                        a?.title?.localeCompare(
                                                                            b?.title
                                                                        )
                                                                )}
                                                                getOptionLabel={(
                                                                    option
                                                                ) =>
                                                                    option?.title ||
                                                                    ""
                                                                }
                                                                value={
                                                                    selectedKeyAccountManager
                                                                }
                                                                onChange={(
                                                                    event,
                                                                    newValue
                                                                ) =>
                                                                    setSelectedKeyAccountManager(
                                                                        newValue ||
                                                                            []
                                                                    )
                                                                }
                                                                isOptionEqualToValue={(
                                                                    option,
                                                                    value
                                                                ) =>
                                                                    option.title ===
                                                                    value?.title
                                                                }
                                                                renderInput={(
                                                                    params
                                                                ) => (
                                                                    <TextField
                                                                        {...params}
                                                                        label="Key Account Manager"
                                                                        placeholder="Select Key Account Manager"
                                                                    />
                                                                )}
                                                            />
                                                        )}
                                                    </Box>
                                                ) : (
                                                    <Box
                                                        display="flex"
                                                        justifyContent="center"
                                                        alignItems="center"
                                                        height="50vh"
                                                    >
                                                        <ThreeDot
                                                            color="#1976d2"
                                                            size="medium"
                                                            text=""
                                                            textColor=""
                                                        />
                                                    </Box>
                                                )}
                                                {/* Apply / Cancel Buttons */}
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        justifyContent:
                                                            "space-between",
                                                        mt: 2
                                                    }}
                                                >
                                                    <Button
                                                        onClick={handleClose}
                                                        color="error"
                                                    >
                                                        CANCEL
                                                    </Button>
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        onClick={handleApply}
                                                    >
                                                        APPLY
                                                    </Button>
                                                </Box>
                                            </Paper>
                                        </Popper>
                                    </Box>
                                </Grid>
                            </Grid>
                        )}
                    </Grid>
                    <Grid size={{ xs: 12, md: 5 }}>
                        {value === "1" && selectedRows?.length > 0 && (
                            <>
                                <div style={{ float: "right" }}>
                                    <Button
                                        variant="contained"
                                        color="error"
                                        size="small"
                                        disabled={isButtonDisable}
                                        onClick={handleClickOpenDialog}
                                        sx={{ marginRight: "10px" }}
                                    >
                                        Reject
                                    </Button>

                                    <Button
                                        variant="contained"
                                        color="success"
                                        size="small"
                                        disabled={isButtonDisable}
                                    >
                                        Accept
                                    </Button>
                                    <Dialog
                                        open={openDialog}
                                        onClose={handleCloseDialog}
                                        maxWidth={maxWidth}
                                        fullWidth
                                        aria-labelledby="responsive-dialog-title"
                                    >
                                        <DialogTitle id="responsive-dialog-title">
                                            {"Reason for Rejection"}
                                        </DialogTitle>
                                        <div style={{ padding: "0 20px" }}>
                                            <TextField
                                                id="outlined-multiline-static"
                                                label="Add your comments"
                                                multiline
                                                rows={4}
                                                value={reasonForRejection}
                                                onChange={(e) =>
                                                    setReasonForRejection(
                                                        e?.target?.value
                                                    )
                                                }
                                                InputLabelProps={{
                                                    shrink: true
                                                }}
                                                fullWidth
                                            />
                                        </div>
                                        <DialogActions>
                                            <Button
                                                autoFocus
                                                color="error"
                                                onClick={handleCloseDialog}
                                            >
                                                Cancel
                                            </Button>
                                            <Button
                                                disabled={
                                                    reasonForRejection?.length <=
                                                    0
                                                }
                                                autoFocus
                                            >
                                                Submit
                                            </Button>
                                        </DialogActions>
                                    </Dialog>
                                </div>
                            </>
                        )}
                    </Grid>
                    <Grid size={{ xs: 12, md: 12 }}>
                        {/* Selected Filters as Chips */}
                        {isApplyFilter == true && (
                            <Box
                                sx={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: 1
                                }}
                                mb={2}
                            >
                                {filteredSelectedSourcingManager?.map(
                                    (item, index) => (
                                        <Chip
                                            key={`sourcingManager-${index}`}
                                            label={item.title}
                                            onDelete={() =>
                                                handleRemoveFilter(
                                                    "sourcingManager",
                                                    item
                                                )
                                            }
                                            size="small"
                                        />
                                    )
                                )}
                                {filteredSelectedIndustry?.map(
                                    (item, index) => (
                                        <Chip
                                            key={`industry-${index}`}
                                            label={item?.title}
                                            onDelete={() =>
                                                handleRemoveFilter(
                                                    "industry",
                                                    item
                                                )
                                            }
                                            size="small"
                                        />
                                    )
                                )}
                                {filteredSelectedStatus?.map((item, index) => (
                                    <Chip
                                        key={`status-${index}`}
                                        label={item?.title}
                                        onDelete={() =>
                                            handleRemoveFilter("status", item)
                                        }
                                        size="small"
                                    />
                                ))}
                                {filteredSelectedCompany?.map((item, index) => (
                                    <Chip
                                        key={`company-${index}`}
                                        label={item?.title}
                                        onDelete={() =>
                                            handleRemoveFilter("company", item)
                                        }
                                        size="small"
                                    />
                                ))}
                                {filteredSelectedMarginRange?.map(
                                    (item, index) => (
                                        <Chip
                                            key={`machine-${index}`}
                                            label={item?.title}
                                            onDelete={() =>
                                                handleRemoveFilter(
                                                    "marginRange",
                                                    item
                                                )
                                            }
                                            size="small"
                                        />
                                    )
                                )}

                                {filteredSelectedKeyAccountManager?.map(
                                    (item, index) => (
                                        <Chip
                                            key={`keyAccountManager-${index}`}
                                            label={item.title}
                                            onDelete={() =>
                                                handleRemoveFilter(
                                                    "keyAccountManager",
                                                    item
                                                )
                                            }
                                            size="small"
                                        />
                                    )
                                )}
                                {/* Clear All Button - Show only when filters exist */}
                                {filteredSelectedSourcingManager?.length +
                                    filteredSelectedIndustry?.length +
                                    filteredSelectedStatus?.length +
                                    filteredSelectedMarginRange?.length +
                                    filteredSelectedKeyAccountManager?.length +
                                    filteredSelectedCompany?.length >
                                    0 && (
                                    <Button
                                        size="small"
                                        variant="outlined"
                                        onClick={handleClearAllChip}
                                        sx={{
                                            fontSize: ".75rem !important",
                                            lineHeight: "1",
                                            borderRadius: "30px"
                                        }}
                                    >
                                        CLEAR ALL
                                    </Button>
                                )}
                            </Box>
                        )}
                    </Grid>
                </Grid>
                <Paper
                    sx={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "62vh"
                    }}
                >
                    {showLoader && (
                        <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            height="100%"
                        >
                            <ThreeDot color="#1976d2" size="medium" />
                        </Box>
                    )}

                    {showGrid && (
                        <DataGridPro
                            pinnedColumns={pinnedColumns}
                            onPinnedColumnsChange={handlePinnedColumnsChange}
                            getRowHeight={() => "auto"}
                            rows={filteredRows}
                            columns={value === "4" ? finalColumns : columns}
                            pagination={filteredRows.length > 10}
                            paginationModel={paginationModel}
                            onPaginationModelChange={setPaginationModel}
                            pageSizeOptions={[10, 20]}
                            rowSelectionModel={selectedRows}
                            disableRowSelectionOnClick
                            initialState={{
                                sorting: {
                                    sortModel: [
                                        { field: "lastUpdateOn", sort: "desc" }
                                    ]
                                }
                            }}
                            sx={{ width: "100%" }}
                        />
                    )}

                    {showEmpty && (
                        <Box
                            display="flex"
                            flexDirection="column"
                            alignItems="center"
                            justifyContent="center"
                            height="100%"
                            gap={1}
                        >
                            {searchTerm || isApplyFilter ? (
                                "No Options available"
                            ) : (
                                <>
                                    <img
                                        src={emptyImage}
                                        alt="Empty"
                                        width="300"
                                    />
                                    <b style={{ color: "#0009" }}>
                                        CORFQs that pass feasibility will appear
                                        here
                                    </b>
                                </>
                            )}
                        </Box>
                    )}
                </Paper>
                <CertificationDrawer
                    open={openDrawer}
                    onClose={handleCloseDrawer}
                    selectedPartner={selectedRow}
                />
            </Box>
        </>
    );
};
